export const SUPER_ADMIN_DEFAULT_LANGS = [
	{ name: "english", isDefault: true },
	{ name: "arabic", isDefault: false },
	{ name: "french", isDefault: false },
];

export const emptyLocalizedName = () => ({
	english: "",
	arabic: "",
	french: "",
});

/** Normalize API/form name: object, legacy string, or empty. */
export const normalizeLocalizedName = (name) => {
	if (!name) {
		return emptyLocalizedName();
	}
	if (typeof name === "string") {
		return { ...emptyLocalizedName(), english: name };
	}
	return {
		english: name.english ?? "",
		arabic: name.arabic ?? "",
		french: name.french ?? "",
	};
};

/** Display label for tables and messages (English first, then fallbacks). */
export const resolveLocalizedLabel = (name, preferredLang = "english") => {
	const normalized = normalizeLocalizedName(name);
	if (normalized[preferredLang]) {
		return normalized[preferredLang];
	}
	return normalized.english || normalized.arabic || normalized.french || "";
};

export const localizedNameMatchesSearch = (name, search) => {
	if (!search) {
		return true;
	}
	const q = search.toLowerCase();
	const normalized = normalizeLocalizedName(name);
	return SUPER_ADMIN_DEFAULT_LANGS.some((lang) =>
		normalized[lang.name]?.toLowerCase().includes(q)
	);
};

export const isNameExistError = (res) =>
	res?.data?.code === "name-exist" || res?.data?.error === "name-exist";

export const getPaymentBillErrorMessage = (res, fallback) => {
	if (isNameExistError(res)) {
		return res?.data?.message || "Payment bill English name already exists";
	}
	return res?.data?.message || fallback;
};
